import { render, staticRenderFns } from "./newstwo.vue?vue&type=template&id=19727e6b&scoped=true"
var script = {}
import style0 from "./newstwo.vue?vue&type=style&index=0&id=19727e6b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19727e6b",
  null
  
)

export default component.exports